import { FaceColor, FaceVariant } from '../../models/clients.model';

export interface FaceVariantMeta {
  value: FaceVariant;
  /** Human-readable label shown in the picker UI. Can be changed freely. */
  label: string;
  /** Path to the preview thumbnail (relative to public/). */
  previewUrl: string;
}

export interface FaceColorMeta {
  value: FaceColor;
  /** Human-readable label shown below the swatch. Can be changed freely. */
  label: string;
  /** Hex color used as the swatch background color. */
  hex: string;
}

/**
 * Face variant options for the picker UI.
 * `value` is the stable DB identifier — never rename without a migration.
 * `label` can be freely updated without any backend or DB changes.
 */
export const FACE_VARIANTS: FaceVariantMeta[] = [
  { value: 'face_1', label: 'Standaard', previewUrl: 'face-previews/face_1.png' },
  { value: 'face_2', label: 'Vrolijk', previewUrl: 'face-previews/face_2.png' },
  { value: 'face_3', label: 'Stralend', previewUrl: 'face-previews/face_3.png' },
  { value: 'face_4', label: 'Rustig', previewUrl: 'face-previews/face_4.png' },
  { value: 'face_5', label: 'Robo', previewUrl: 'face-previews/face_5.png' },
];

/**
 * Face color options for the picker UI.
 * `value` is the stable DB identifier — never rename without a migration.
 * `label` and `hex` can be freely updated.
 */
export const FACE_COLORS: FaceColorMeta[] = [
  { value: 'blue', label: 'Blauw', hex: '#5ebfea' }, // #2ed3f7
  { value: 'mint', label: 'Mint', hex: '#65fbd8' }, // #00bfa5
  { value: 'green', label: 'Groen', hex: '#82fb8a' }, // #4caf50
  { value: 'yellow', label: 'Geel', hex: '#fadb33' }, // #ffc107
  { value: 'purple', label: 'Paars', hex: '#9a82fa' }, // #9c27b0
  { value: 'magenta', label: 'Magenta', hex: '#e73de4' }, // #e91e8c
];
